import { ReactNode } from "react"
import { ClassName } from "../Components"
import { Block, BlockContainer, BlockRow } from "./Block"

interface PrintListBlockProps {
  title: ReactNode;
  visible?: boolean;
  blockClassName?: ClassName;
  after?: ReactNode;
  children?: ReactNode;
}

// Display-only shell shared by the read-only PrintShip section views: a boxed
// container wrapping a titled block whose rows the caller supplies as children.
// Each view keeps computing its own data/visibility; this only owns the common
// container/block/title structure and the "render nothing when hidden" guard.
export function PrintListBlock({ title, visible = true, blockClassName, after, children }: PrintListBlockProps) {
  if (!visible) {
    return null;
  }

  return (
    <BlockContainer className="container-boxed">
      <Block className={blockClassName}>
        <BlockRow>
          <h3>{title}</h3>
        </BlockRow>
        {children}
      </Block>
      {after}
    </BlockContainer>
  );
}
